import s from "./ghl-ui.es1157.js";
import { composite as r } from "./ghl-ui.es904.js";
const p = (a) => {
  const {
    borderRadius: e,
    avatarColor: o,
    cardColor: t,
    fontSize: i,
    heightTiny: l,
    heightSmall: h,
    heightMedium: m,
    heightLarge: c,
    heightHuge: g,
    modalColor: n,
    popoverColor: d
  } = a;
  return {
    borderRadius: e,
    fontSize: i,
    border: `2px solid ${t}`,
    heightTiny: l,
    heightSmall: h,
    heightMedium: m,
    heightLarge: c,
    heightHuge: g,
    color: r(t, o),
    colorModal: r(n, o),
    colorPopover: r(d, o)
  };
}, v = {
  name: "Avatar",
  common: s,
  self: p
}, C = v;
export {
  C as default,
  p as self
};
